<template>
  <div class="my-3">
    <b-row v-if="stMedicamentosList.length > 0">

      <b-col>
        <span><strong>Tabla de Receta </strong></span>
        <b-table 
          :items="stMedicamentosList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(medicamento)="data">
            {{ data.item.medicamento }}
          </template>
          <template #cell(acciones)="data">
            <b-button
              variant="primary"
              size="sm"
              style="cursor: pointer"
              @click="onEditMedicamento(data.item)"
            >
              <font-awesome-icon
                icon="user-pen"
                style="color: rgb(253, 253, 253)"
              />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              style="cursor: pointer"
              @click="removeItemMedicamento(data.item.id)"
            >
              <font-awesome-icon
                icon="circle-xmark"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
      
    </b-row>
    <b-row>
      <b-button class="ml-2" variant = "info" @click="copyAs400">
        copyAS400
      </b-button>
    </b-row>

    <MedicamentoModalEdit 
      :medicamento="dataEdit"
      :showModalEdit.sync="showModalEdit" 
    />
  </div>
   
</template>

<script>
import { copyText } from '@/shared/helpers';
import { mapState } from 'vuex';
import MedicamentoModalEdit from './MedicamentoModalEdit.vue';

export default {

  name: "RecetaTable",

  components: {
    MedicamentoModalEdit
  },

  data(){
    return{

      showModalEdit: false,
      dataEdit: null,

      tableFields: [
        { key: "medicamento", label: "Medicamento", thClass: "text-center" },
        { key: "cantidad",    label: "Cantidad",    thClass: "text-center" },
        { key: "dosis",       label: "Dosis",       thClass: "text-center" },        
        { key: "frecuencia",  label: "Frecuencia",  thClass: "text-center" },
        { key: "duracion",    label: "Duracion",    thClass: "text-center" },
        { key: "via",         label: "Via",         thClass: "text-center" },
        { key: "observacion", label: "Observación", thClass: "text-center" },
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        },
      ],

    }
  },


  methods:{
    copyAs400(){
       
      const textoArray = this.stMedicamentosList.map( 
        m => `-${m.medicamento}, cantidad: ${m.cantidad}, dosis: ${m.dosis}, frecuencia: ${m.frecuencia}, duracion: ${m.duracion} via: ${m.via}, observacion: ${m.observacion} \n`
      ).join("");
      
      copyText(textoArray)
    },

    
    onEditMedicamento(item){
      this.showModalEdit = true;
      this.dataEdit = item;
    },

    removeItemMedicamento(itemId) {

      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar!",
        cancelButtonText: "No, cancelar",
      })
        .then( result => {
          if (result.isConfirmed) {

            const newMedicamentosList = this.stMedicamentosList.filter(
              (item) => item.id !== itemId
            );

            // console.log( 'newMedicamentosList', newMedicamentosList );

            this.$store.commit("setMedicamentosList", newMedicamentosList );
            this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");

          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);

          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },

  },

  computed: {
    ...mapState({
      stMedicamentosList: state => state.atencionCita.receta.medicamentosList,
    }),
  },

}
</script>